import React from "react";
import type { EventDTO } from "../lib/api";
import { trackEvent } from "../lib/analytics";
import { IconMap, IconTicket } from "./icons";

/**
 * Outbound-link chips on every event card: Tickets + Map.
 */
export function AffiliateStrip({
  event,
  onClickCapture,
}: {
  event: EventDTO;
  /** Parent calls this to suppress the card-wide tap when a chip is hit. */
  onClickCapture?: (e: React.MouseEvent) => void;
}) {
  const a = event.affiliates;
  if (!a.tickets && !a.transport) return null;

  const go = (
    kind: "tickets" | "transport",
    url: string | null,
  ) =>
    (e: React.MouseEvent) => {
      if (!url) return;
      e.stopPropagation();
      onClickCapture?.(e);
      trackEvent("outbound_affiliate", { kind, event: event.slug });
    };

  return (
    <div className="affiliate-strip" data-testid="affiliate-strip">
      {a.tickets && (
        <a
          href={a.tickets}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="aff-chip aff-tickets"
          onClick={go("tickets", a.tickets)}
          data-testid="aff-tickets"
          aria-label={`Buy tickets to ${event.name}`}
        >
          <IconTicket />
          <span>Tickets</span>
        </a>
      )}
      {a.transport && (
        <a
          href={a.transport}
          target="_blank"
          rel="noopener noreferrer"
          className="aff-chip aff-map"
          onClick={go("transport", a.transport)}
          data-testid="aff-map"
          aria-label={`Directions to ${event.location ?? event.name}`}
        >
          <IconMap />
          <span>Map</span>
        </a>
      )}
    </div>
  );
}
